import React from "react";
import PropTypes from "prop-types";
import "./style.scss";
import { useTranslation } from "react-i18next";

const propTypes = {
  category: PropTypes.number,
  changeCategory: PropTypes.func,
};

const HeaderTabs = ({ category, changeCategory }) => {
  const { t } = useTranslation();

  return (
    <section id="HeaderTabs">
      <>
        <nav className="headertabs__tabs">
          <a href="https://www.okayama-kanko.jp/experience">
            <div className="headertabs__item">
              <span> 体験レポート </span>
            </div>
          </a>
          <div onClick={() => changeCategory(2)}>
            <div className="headertabs__item active">
              <span> 体験をネットで予約 </span>
            </div>
          </div>
          <a href="https://www.okayama-kanko.jp/event/list?sortType=date&listStyle=list&latitude=&longitude=&keyword=&category_m%5B%5D=121&distance%5B%5D=#searchResultArea">
            <div className="headertabs__item">
              <span> ツアー </span>
            </div>
          </a>
        </nav>
        <div className="headertabs__title">
          <div className="inner">
            <span>
              {parseInt(category) === 1 ? t("activity") : t("restaurant")}
            </span>
          </div>
        </div>
      </>
    </section>
  );
};

HeaderTabs.propTypes = propTypes;

export default HeaderTabs;
